import React from 'react';
import './PermissionsPromptModal.scss';
import faceIcon from '../images/face-icon.svg';
import { FaBell } from 'react-icons/fa';
import { getHowToEnablePath } from '../services/pushPermissionReminders';

function getLeadCopy(variant, notificationDenied) {
  if (variant === 'after-response') {
    return 'We have saved your response. Turn on notifications so the next match or training update arrives on this phone instead of by text.';
  }
  if (variant === 'howto' || notificationDenied) {
    return 'Notifications are off on this phone. Here is how to switch them on.';
  }
  return 'Get notified about matches, training sessions, and important updates.';
}

function PermissionsPromptModal({
  showNotificationPrompt,
  showBiometricPrompt,
  notificationDenied,
  howToSteps = [],
  variant = 'login',
  onEnableNotifications,
  onEnableBiometric,
  onOpenSettings,
  onCheckAgain,
  onSkip,
  onClose
}) {
  React.useEffect(() => {
    console.log('[PermissionsModal] notificationDenied changed:', notificationDenied);
    console.log('[PermissionsModal] showNotificationPrompt:', showNotificationPrompt);
  }, [notificationDenied, showNotificationPrompt]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const hasAnyPrompt = showNotificationPrompt || showBiometricPrompt;
  const showHowTo = showNotificationPrompt && (notificationDenied || variant !== 'login');

  if (!hasAnyPrompt) {
    return null;
  }

  return (
    <div
      className="modal-overlay permissions-modal-overlay"
      onClick={handleOverlayClick}
      onMouseDown={(e) => e.preventDefault()}
    >
      <div
        className="modal permissions-prompt-modal"
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="permissions-list">
            {showNotificationPrompt && (
              <div className="permission-item">
                <div className="permission-icon notification-icon">
                  <FaBell />
                </div>
                <div className="permission-info">
                  <h3>
                    {notificationDenied || variant !== 'login'
                      ? "Don't miss out on announcements"
                      : 'Push Notifications'}
                  </h3>
                  <p className="important-message">{getLeadCopy(variant, notificationDenied)}</p>
                  {showHowTo && howToSteps.length > 0 && (
                    <ol className="notification-how-to">
                      {howToSteps.map((step) => (
                        <li key={step}>{step}</li>
                      ))}
                    </ol>
                  )}
                  {!notificationDenied && variant === 'login' && howToSteps.length === 0 && (
                    <p>Get notified about matches, training sessions, and important updates</p>
                  )}
                  {showHowTo && (
                    <p className="settings-instruction">
                      Path: {getHowToEnablePath()}
                    </p>
                  )}
                </div>
                {notificationDenied || variant !== 'login' ? (
                  <div className="denied-buttons">
                    <button
                      onClick={onOpenSettings}
                      className="enable-btn settings-btn"
                      onFocus={(e) => { e.target.style.outline = 'none'; }}
                    >
                      Open Settings
                    </button>
                    <button
                      onClick={onCheckAgain}
                      className="enable-btn check-again-btn"
                      onFocus={(e) => { e.target.style.outline = 'none'; }}
                    >
                      I&apos;ve enabled them
                    </button>
                    {!notificationDenied && (
                      <button
                        onClick={onEnableNotifications}
                        className="enable-btn"
                        onFocus={(e) => { e.target.style.outline = 'none'; }}
                      >
                        Enable
                      </button>
                    )}
                  </div>
                ) : (
                  <button
                    onClick={onEnableNotifications}
                    className="enable-btn"
                    onFocus={(e) => { e.target.style.outline = 'none'; }}
                  >
                    Enable
                  </button>
                )}
              </div>
            )}

            {showBiometricPrompt && (
              <div className="permission-item">
                <div className="permission-icon biometric-icon">
                  <img src={faceIcon} alt="Face ID" />
                </div>
                <div className="permission-info">
                  <h3>Face ID Login</h3>
                  <p>Sign in quickly and securely with Face ID</p>
                </div>
                <button
                  onClick={onEnableBiometric}
                  className="enable-btn"
                  onFocus={(e) => { e.target.style.outline = 'none'; }}
                >
                  Enable
                </button>
              </div>
            )}
          </div>

          <div className="modal-buttons">
            <button
              onClick={onSkip}
              className="secondary-btn skip-btn"
              onFocus={(e) => { e.target.style.outline = 'none'; }}
            >
              Skip for now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PermissionsPromptModal;
